import { Snackbar } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { Alert } from '@mui/material';
import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getNotificationFromApi } from '../../api';
import { handleGlobalApiCalls, logout } from '../../helpers/asyncActions';
import { getProfilePic } from '../../helpers/images';
import {
  getNotificationItems,
  setNewMeeting,
  setNewNotification,
} from '../../helpers/users';
import { useGlobalContext } from '../../stores/global';
import styles from './UserMenu.module.scss';

export default function UserMenu() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notification, setNotification] = useState(0);
  const [open, setOpen] = React.useState(false);
  const { user, isLoading, dispatch } = useGlobalContext();
  const chatMessagesPollingIntervalRef = useRef<number>();

  const { showNotification, isEmailOrPhoneVerified } = getNotificationItems(
    user
  );

  // Polling notification
  let minValue = parseInt(localStorage.getItem('notification') || '0');
  const startNotificationPolling = () => {
    getNotification();
    window.clearInterval(chatMessagesPollingIntervalRef.current);
    chatMessagesPollingIntervalRef.current = window.setInterval(() => {
      getNotification();
      // }, 5000 * 100000); // TODO: enable polling again
    }, 5000);
  };

  const getNotification = () => {
    return getNotificationFromApi().then((response) => {
      const messages = response.data.data?.length;
      const meetings = response.data.data?.lengthMeetings;
      if (messages > minValue) {
        setOpen(true);
      }
      localStorage.setItem('notification', messages);
      minValue = messages;
      setNewNotification(messages > 0 ? true : false);
      setNewMeeting(meetings > 0 ? true : false);
      setNotification(messages);
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    handleGlobalApiCalls(dispatch, isLoading, null, () =>
      Promise.resolve()
        .then(() => startNotificationPolling())
        .catch((err) => {
          setNotification(0);
          throw err;
        })
    );

    return () => {
      window.clearInterval(chatMessagesPollingIntervalRef.current);
    };
  }, []);

  return (
    <>
      <ClickAwayListener
        onClickAway={() => showDropdown && setShowDropdown(false)}
      >
        <div
          className={clsx(
            styles.container,
            showDropdown && styles.showDropdown
          )}
        >
          {showNotification ||
            (notification > 0 && <div className={styles.notification} />)}
          <button
            className={styles.mainBtn}
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <img src={getProfilePic(user?.photo)} />
          </button>

          <div className={styles.dropdown}>
            <Link onClick={() => setShowDropdown(false)} to="/me">
              {!isEmailOrPhoneVerified && (
                <div className={styles.notification} />
              )}
              <i className="fonticons fonticons-user" />
              Perfil
            </Link>
            {/* <Link onClick={() => setShowDropdown(false)} to="/messages">
              {notification > 0 && <div className={styles.notification} />}
              <i className="fonticons fonticons-email" />
              Mis mensajes{' '}
            </Link> */}
            {/* <Link onClick={() => setShowDropdown(false)} to="/me/properties">
              <i className="fonticons fonticons-home2" />
              Mis propiedades
            </Link> */}
            <Link onClick={() => setShowDropdown(false)} to="/favorites">
              <i className="fonticons fonticons-heart" />
              Mis favoritos
            </Link>
            <div
              className={styles.cursorPointer}
              onClick={() => {
                setShowDropdown(false);
                logout(dispatch);
              }}
            >
              <i className="fonticons fonticons-logout" />
              Cerrar sesión
            </div>
          </div>
        </div>
      </ClickAwayListener>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={4000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="success">
          ¡Tienes nuevas notificaciones!
        </Alert>
      </Snackbar>
    </>
  );
}
